import { HttpContextToken } from '@angular/common/http';

/** Marca peticiones que no deben pasar por el interceptor (login, refresh, etc.). */
export const SKIP_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
